export enum WorkspaceExplorerMode {
  Select = 'select',
  Move = 'move',
  Copy = 'copy',
  Upload = 'upload',
  UploadToImagePlayground = 'upload-to-image-playground',
}

export enum WorkspaceExplorerSelectionMode {
  UploadFile = 'upload-file',
  SelectFromWorkspace = 'select-from-ws',
}
